import { render, staticRenderFns } from "./AppKionCode.vue?vue&type=template&id=39bb92e4"
import script from "./AppKionCode.vue?vue&type=script&lang=ts"
export * from "./AppKionCode.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports